import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class AssistantsDialog extends Component {

  renderService = (assistants, index) => {
    const { t } = this.props;

    return(
      <div key={index}>
        <table>
          <tbody>
            <tr>
              <td><img className="profile-picture" alt={t('dashboard.navbar.img_user')} src={assistants.picture} />&emsp;</td>
              <td>
                <strong>{assistants.name}</strong>&emsp;
                {assistants.member_id && <span className="text-primary">{t('dashboard.events.is_member')}</span>}
                <br />
                {assistants.job_title} {assistants.company && t('dashboard.events.label_from')} <strong>{assistants.company}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const event = JSON.parse(this.props.location.state.event);
    const assistants_number = event.assistants.length;
    
    return(
      <div>
        <div className="modal fade" id="modalAssistants" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4 className="text-primary">
                  {assistants_number==1 && assistants_number+' '+t('dashboard.events.one_assistants')}
                  {assistants_number>1 && assistants_number+' '+t('dashboard.events.many_assistants')}
                </h4>
                <div>
                  {event.assistants.map(
                      (_, index) => this.renderService(event.assistants[index], index)
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(AssistantsDialog);



// WEBPACK FOOTER //
// ./src/dashboard/events/AssistantsDialog.js